import React from 'react';
import { Mic } from 'lucide-react';

export default function RecordButton({ variant = 'floating', onClick, disabled = false }) {
  if (variant === 'prominent') {
    // Large button for Home tab - placed below nav, above cover photo
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        className="w-full bg-gradient-to-r from-brand to-brand-magenta hover:opacity-90 
          disabled:opacity-disabled disabled:cursor-not-allowed transition px-6 h-btn 
          font-semibold text-sm flex items-center justify-center gap-3 
          shadow-lg shadow-purple-500/30 rounded-pill"
      >
        <Mic className="w-6 h-6" />
        Record Idea
      </button>
    );
  }

  // Floating button for other tabs
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="fixed bottom-6 right-6 bg-gradient-to-r from-brand to-brand-magenta 
        hover:opacity-90 disabled:opacity-disabled disabled:cursor-not-allowed 
        transition p-4 shadow-lg shadow-purple-500/30 z-40 rounded-full"
      title="Record Idea"
    >
      <Mic className="w-6 h-6 text-white" />
    </button>
  );
}
